import { render, staticRenderFns } from "./Panorama.vue?vue&type=template&id=4b64ca15"
import script from "./Panorama.vue?vue&type=script&lang=js"
export * from "./Panorama.vue?vue&type=script&lang=js"
import style0 from "./Panorama.vue?vue&type=style&index=0&id=4b64ca15&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports